import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/resultados-rit";

/**
 * Consulta el consolidado de encuestas (509, 573, 667) para una cédula.
 * @param {string} cedula
 * @returns {{ ok: boolean, message: string, data: { sujetoid, encuesta_509, encuesta_573, encuesta_667 } }}
 */
export const obtenerResultadosPorCedula = async (cedula) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/${cedula}`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo resultados RIT por cédula:", error);
    throw error;
  }
};

/**
 * Consulta el reporte Kokam (aprobados) por identificación.
 * @param {string} identificacion
 * @returns {{ ok: boolean, message: string, data: Array }}
 */
export const obtenerKokamPorIdentificacion = async (identificacion) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/kokam/${identificacion}`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo reporte Kokam:", error);
    throw error;
  }
};